import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { ProcessLink } from "../../global/helpers"

// Import static.svg to use css animation, animated.svg to use SVG animation. Search and replace the suffix to switch.
import IconHomepageChip from "./icons_svg/homepage-chip-static.svg";
import IconHomepageCalculation from "./icons_svg/homepage-calculation-static.svg";
import IconHomepageGraph from "./icons_svg/homepage-graph-static.svg";
import IconHomepageWorld from "./icons_svg/homepage-world-static.svg";
import IconPolitical from "./icons_svg/political-static.svg";
import IconMilitary from "./icons_svg/military-static.svg";
import IconEconomic from "./icons_svg/economic-static.svg";
import IconSocial from "./icons_svg/social-static.svg";
import IconInformation from "./icons_svg/information-static.svg";
import IconInfrastructure from "./icons_svg/infrastructure-static.svg";
import IconPhysEnv from "./icons_svg/phys-env-static.svg";
import IconRemote from "./icons_svg/remote-static.svg";
import IconCompensation from "./icons_svg/compensation-static.svg";
import IconPTO from "./icons_svg/pto-static.svg";
import IconHealthcare from "./icons_svg/healthcare-static.svg";
import IconStipend from "./icons_svg/stipend-static.svg";
import IconStock from "./icons_svg/stock-static.svg";
import IconRetirement from "./icons_svg/retirement-static.svg";
import IconProDev from "./icons_svg/pro-dev-static.svg";
import "./icons_svg/style-static.scss";

/**
 * Icons Mapping
 */
const IconsMapping = {
  homepage_chip: IconHomepageChip,
  homepage_calculations: IconHomepageCalculation,
  homepage_graph: IconHomepageGraph,
  homepage_world: IconHomepageWorld,
  politics: IconPolitical,
  military: IconMilitary,
  economic: IconEconomic,
  social: IconSocial,
  information: IconInformation,
  infrastructure: IconInfrastructure,
  physical_environment: IconPhysEnv,
  stock_options: IconStock,
  stipend: IconStipend,
  retirement: IconRetirement,
  remote: IconRemote,
  pto: IconPTO,
  pro_devo: IconProDev,
  healthcare: IconHealthcare,
  compensation: IconCompensation,
}

const IconAnimated = ({ blok }) => {
  const link = ProcessLink(blok.link)

  const style = {}
  if (blok.max_size) {
    style.width = `${blok.max_size}px`
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="icon_animated component"
      key={blok._uid}
      style={style}
    >
      {IconsMapping[blok.icon] && (
        <React.Fragment>
          {blok.link.url || blok.link.id ? (
            <a
              href={link.url}
              target={link.target}
              aria-label="Icon Link"
              className={link.cssClass}
            >
              {React.createElement(IconsMapping[blok.icon], {})}
            </a>
          ) : (
            React.createElement(IconsMapping[blok.icon], {})
          )}
        </React.Fragment>
      )}
    </div>
  )
}

export default IconAnimated
